import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    sessionExpiredAcknowledged: false,
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        hideSessionExpiredDialog(state) {
            return { ...state, sessionExpiredAcknowledged: true };
        },
    },
});

export const { hideSessionExpiredDialog } = appSlice.actions;

export default appSlice.reducer;
